// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const BUILDINFO = {
  "hash": "d53584fc2b7d6ec739fe8e0443ba40b43baa1f2c",
  "tag": "",
  "github": {
    "runId": "",
    "runNumber": "",
    "runAttempt": ""
  }
};
/* tslint:enable */
